export enum bankStatusEnum {
    Inactive,
    Active,
    'Error',
  }
  
  export namespace bankStatusEnum {
    export function values() {
      return Object.keys(bankStatusEnum).filter(
        (type) => isNaN(<any>type) && type !== 'values'
      );
    }
  }
  